import { Component } from "@theme/component";

/**
 * A custom element that formats rte content for easier styling
 */
class RTEFormatter extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.querySelectorAll("table").forEach(this.#formatTable);
    this.#applyImageAltFallbacks();
    this.#normalizeHeadingLevels();
  }

  /**
   * Formats a table for easier styling
   * @param {HTMLTableElement} table
   */
  #formatTable(table) {
    const wrapper = document.createElement("div");
    wrapper.classList.add("rte-table-wrapper");
    const parent = table.parentNode;
    if (parent) {
      parent.insertBefore(wrapper, table);
      wrapper.appendChild(table);
    }
  }

  #applyImageAltFallbacks() {
    const defaultAlt = this.dataset.defaultImageAlt?.trim();

    if (!defaultAlt) return;

    this.querySelectorAll("img").forEach((image) => {
      const currentAlt = image.getAttribute("alt");

      if (currentAlt === null || currentAlt.trim() === "") {
        image.setAttribute("alt", defaultAlt);
      }
    });
  }

  #normalizeHeadingLevels() {
    const maxHeadingLevel = Number.parseInt(
      this.dataset.maxHeadingLevel || "",
      10,
    );

    if (!maxHeadingLevel || maxHeadingLevel < 1 || maxHeadingLevel > 6) return;

    this.querySelectorAll("h1, h2, h3, h4, h5, h6").forEach((heading) => {
      const currentLevel = Number.parseInt(heading.tagName.slice(1), 10);

      if (Number.isNaN(currentLevel) || currentLevel >= maxHeadingLevel) return;

      const nextHeading = document.createElement(`h${maxHeadingLevel}`);
      Array.from(heading.attributes).forEach((attribute) => {
        nextHeading.setAttribute(attribute.name, attribute.value);
      });
      nextHeading.innerHTML = heading.innerHTML;
      heading.replaceWith(nextHeading);
    });
  }
}

if (!customElements.get("rte-formatter")) {
  customElements.define("rte-formatter", RTEFormatter);
}
